export enum AnalyticsPages {
  CALLS = 'calls',
}

export const AnalyticsPlaces = {
  LIST: 'CallsList',
}
